"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("@/Components/UI/Modal"));
const styled_1 = __importDefault(require("./styled"));
const FavoriteShiptosSelect_1 = __importDefault(require("./FavoriteShiptosSelect"));
const Typography_1 = require("@/Components/UI/Typography");
const Hooks_1 = require("@/Hooks");
const index_1 = require("Types/index");
const svg_components_1 = require("@/assets/svg-components");
const user_1 = require("@/Endpoints/user");
const react_redux_1 = require("react-redux");
const favoriteShiptosModal_1 = require("@/Redux/Actions/favoriteShiptosModal");
const Utils_1 = require("@/Utils");
const Constants_1 = require("@/Constants");
const user_2 = require("@/Redux/Actions/user");
const FavoriteShiptosModal = () => {
    const { t } = (0, Hooks_1.useTranslate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [error, setError] = (0, react_1.useState)('');
    const [selectedShipto, setSelectedShipto] = (0, react_1.useState)();
    const [shiptosOptions, setShiptosOptions] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedShipto) {
            setError(t('/haldex/login_modal/you_must_choose_option'));
            return;
        }
        setIsLoading(true);
        const response = yield (0, user_1.setUserShipToAccount)(selectedShipto.customerId.toString());
        if (!response.successful) {
            setError(response.errorMessage);
            setIsLoading(false);
            return;
        }
        yield dispatch((0, user_2.fetchUserData)());
        (0, Utils_1.setCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED, 'true', 1);
        setIsLoading(false);
        dispatch((0, favoriteShiptosModal_1.setIsFavoriteShiptosModalOpen)(false));
    });
    const getShiptosOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield (0, user_1.getShippingAccounts)();
            setShiptosOptions(response.data.shipTos);
        }
        catch (e) {
            setShiptosOptions([]);
        }
    }), []);
    (0, react_1.useEffect)(() => {
        getShiptosOptions();
    }, []);
    const handleAddFavoriteShippingAccounts = (value) => __awaiter(void 0, void 0, void 0, function* () {
        setError('');
        if (!value) {
            return;
        }
        const favoriteShiptos = shiptosOptions.filter(option => option.isFavorite);
        if (favoriteShiptos.length >= 5) {
            setError(t('/haldex/login_modal/max_5_favorite_shiptos'));
            return;
        }
        yield (0, user_1.addFavoriteShippingAccount)(String(value.customerId));
        yield getShiptosOptions();
    });
    const handleRemoveFavoriteShippingAccount = (value) => __awaiter(void 0, void 0, void 0, function* () {
        setError('');
        if (!value) {
            return;
        }
        yield (0, user_1.removeFavoriteShippingAccount)(String(value.customerId));
        yield getShiptosOptions();
    });
    const handleSelectShipto = (value) => {
        setSelectedShipto(value);
        setError('');
    };
    return (react_1.default.createElement(Modal_1.default, null,
        react_1.default.createElement(styled_1.default.LoginContainer, null,
            react_1.default.createElement(styled_1.default.MainContainer, null,
                error && (react_1.default.createElement(styled_1.default.ErrorContainer, null,
                    react_1.default.createElement(svg_components_1.RedWarningIcon, null),
                    react_1.default.createElement(styled_1.default.ErrorText, { type: Typography_1.Types.BODY_2 }, error))),
                react_1.default.createElement(styled_1.default.Title, { type: Typography_1.Types.INTRODUCTORY_TEXT }, t('/haldex/login_modal/title')),
                react_1.default.createElement(FavoriteShiptosSelect_1.default, { disabled: isLoading, onAdd: handleAddFavoriteShippingAccounts, onRemove: handleRemoveFavoriteShippingAccount, options: shiptosOptions, onChange: handleSelectShipto }),
                react_1.default.createElement(styled_1.default.ButtonContainer, null,
                    react_1.default.createElement(styled_1.default.SubmitButton, { type: index_1.ButtonTypes.BUTTON, onClick: handleSubmit, disabled: isLoading }, t('/haldex/login_modal/continue')))))));
};
exports.default = FavoriteShiptosModal;
